<template>
  <v-container class="py-10">
    <v-row justify="center">
      <v-col cols="12" md="10" lg="8">
        <!-- Top header -->
        <h1 class="text-h3 mb-2">Ultimele Știri</h1>
        <p class="text-subtitle-1 text-grey-darken-1 mb-4">
          Cele mai recente anunțuri și actualizări.
        </p>
        <v-divider class="mb-8" />

        <!-- Featured news (latest) -->
        <v-card
          class="elevation-4 mb-10"
          @click="$router.push(`/news/${latestNews.id}`)"
        >
          <v-img
            :src="latestNews.thumbnail"
            height="300px"
            cover
            class="rounded-t"
          />
          <v-card-title class="text-h5">{{ latestNews.title }}</v-card-title>
          <v-card-subtitle>{{ latestNews.date }}</v-card-subtitle>
          <v-card-text>{{ latestNews.summary }}</v-card-text>
        </v-card>

        <!-- Grid of older news -->
        <v-row>
          <v-col
            v-for="newsItem in olderNews"
            :key="newsItem.id"
            cols="12"
            sm="6"
            md="4"
          >
            <v-card
              class="elevation-2"
              @click="$router.push(`/news/${newsItem.id}`)"
            >
              <v-img
                :src="newsItem.thumbnail"
                height="180px"
                cover
                class="rounded-t"
              />
              <v-card-title class="text-subtitle-1">{{
                newsItem.title
              }}</v-card-title>
              <v-card-subtitle>{{ newsItem.date }}</v-card-subtitle>
              <v-card-text>{{ newsItem.summary }}</v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import news from "@/assets/news.json";

export default {
  computed: {
    latestNews() {
      return news[0];
    },
    olderNews() {
      return news.slice(1);
    },
  },
};
</script>
